import { useMutation } from '@apollo/client';

import { CreditCard } from '__generated__/GQL';

import { UpdateCreditCardAliasDocument } from './updateCreditCardAlias.gql';

export const useUpdateCreditCardAlias = () => {
  const [originalUpdateCreditCardAlias, ...rest] = useMutation(
    UpdateCreditCardAliasDocument,
  );
  const updateCreditCardAlias = (
    creditCardId: CreditCard['creditCardId'],
    alias: CreditCard['alias'],
  ) =>
    originalUpdateCreditCardAlias({
      variables: {
        input: {
          alias,
          creditCardId,
        },
      },
    });

  return {
    updateCreditCardAlias,
    ...rest,
  };
};
